const bgColors = {
  yellow: 'bg-yellow-15',
  'yellow-announcement': 'bg-yellow',
  blue: 'bg-blue-7.5',
  'blue-announcement': 'bg-blue text-white',
  'blue-secondary': 'bg-blue-15',
  green: 'bg-green-7.5',
  'green-announcement': 'bg-green text-white',
  'green-secondary': 'bg-green-15',
  orange: 'bg-orange-7.5',
  'orange-announcement': 'bg-orange text-white',
  'orange-secondary': 'bg-orange-15',
  black: 'bg-black text-white',
  transparent: 'bg-transparent',
};

const textColors = {
  'text-black': 'text-black',
  'text-white': 'text-white',
};

export { bgColors, textColors };
